// components/features/invitations/InvitationList.tsx
import React from "react";
import InvitationRow from "./InvitationRow";
import { Invitation } from "../../../types/features/Invitation";
import TableList, { SelectAction } from "../../ui/TableList";

interface InvitationListProps {
  invitations: Invitation[];
  onAction: (invitation: Invitation) => void;
  onSelectInvitations?: (selectedInvitations: Invitation[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function InvitationList({
  invitations,
  onAction,
  onSelectInvitations,
  selectable = false,
  selectActions,
}: InvitationListProps) {
  const columns = [
    { header: "Invitation", className: "w-2/5" },
    { header: "Entreprise", className: "hidden md:table-cell w-1/5" },
    { header: "Email", className: "hidden sm:table-cell w-1/5" },
    { header: "Statut", className: "hidden lg:table-cell w-1/6" },
    { header: "Date", className: "hidden xl:table-cell w-1/6" },
    { header: "Expire", className: "hidden 2xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={invitations}
      columns={columns}
      getId={(invitation) => invitation.id}
      onAction={onAction}
      onSelectItems={onSelectInvitations}
      selectable={selectable}
      emptyMessage="Aucune invitation trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(invitation, isSelected, onSelect) => (
        <InvitationRow
          key={invitation.id}
          invitation={invitation}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}